<div
  [class.square-catalog-timeout]="
    componentInstance() === ComponentInstance?.SquareCatalogComponent
  "
  [class.container]="
    componentInstance() === ComponentInstance?.SquareCatalogComponent
  "
  [class.ticket_checkout]="
    componentInstance() !== ComponentInstance?.SquareCatalogComponent
  ">
  <div
    class="row"
    [class.ticket_timeout_content_panel]="
      componentInstance() === ComponentInstance?.SquareCatalogComponent
    "
    [class.ticket_timeout_panel]="
      componentInstance() !== ComponentInstance?.SquareCatalogComponent
    "
    [class.justify-content-center]="
      componentInstance() !== ComponentInstance?.SquareCatalogComponent
    ">
    <div class="col-md-8 main-inner-container">
      <img
        alt="time out"
        class="img-fluid"
        ngSrc="/assets/images/time-out.png"
        width="401"
        height="377" />
      <p class="time_out_title timeout_title">
        {{ 'timeLimitExpired' | localize }}
      </p>
      <p class="time_out_des timeout_desc">
        {{
          (componentInstance() === ComponentInstance?.SquareCatalogComponent
            ? 'productPurchaseCancelRestartPurchase'
            : 'reservationCancelReStartPurchase'
          ) | localize
        }}
      </p>
      <a
        class="time_out_link"
        role="button"
        data-dismiss="modal"
        data-toggle="modal"
        data-target="#ticket_checkout_popup"
        (click)="redirectHome()"
        >{{
          (componentInstance() === ComponentInstance?.SquareCatalogComponent
            ? 'backToProduct'
            : 'backToTickets'
          ) | localize
        }}</a
      >
    </div>
  </div>
</div>
